import React from 'react';
import BaseModal from "./BaseModal";
import NewSurveyForm from "../surveys/new_survey_form/NewSurveyForm";

function NewSurveyModal(props) {
    return props.modalShown ?
        (
            <BaseModal modalId={"myModal"} modalClass={"modal"} innerDivClass={"modal-content modal-content--noAlign"}>
                <NewSurveyForm closeModal={props.closeModal}/>
            </BaseModal>
        ) : null;
}

export default NewSurveyModal;